import { useContext } from "react";
import { PageContext } from "../contexts/PageContext";

export const usePageMode = () => useContext(PageContext);
